<div class="middle_ware_loading">

    <app-loader></app-loader>
    <div class="middle_ware_loading_text">
        Loading...
    </div>
</div>